import { memo } from 'react';
import styled from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 32px;

  p {
    margin-top: 0;
    margin-bottom: 24px;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 14px;
    font-weight: 500;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  ul li {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 15px;
    color: #474747;

    &.checked {
      color: green;
    }

    /* Remove the default bullet points */
    list-style: none;

    /* Optionally, remove the custom bullets */
    &::before {
      content: none;
    }
  }
`

const PasswordRules = ({ rules }) => {
  return (
    <Container>
      <p>Sua senha precisa ter:</p>
      <ul>
        <li className={rules.uppercase ? 'checked' : ''}>
          Uma letra maiúscula {rules.uppercase && <FaCheckCircle color="green" />}
        </li>
        <li className={rules.lowercase ? 'checked' : ''}>
          Uma letra minúscula {rules.lowercase && <FaCheckCircle color="green" />}
        </li>
        <li className={rules.number ? 'checked' : ''}>
          Um número {rules.number && <FaCheckCircle color="green" />}
        </li>
        <li className={rules.length ? 'checked' : ''}>
          No mínimo 8 caracteres {rules.length && <FaCheckCircle color="green" />}
        </li>
      </ul>
    </Container>
  )
}

export default memo(PasswordRules);
